




































































import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import DashboardView from '@ui/Dashboard/Layout/DashboardView'
import AudienceInsightsDashboardHeader from '@ui/Dashboard/Views/Organizer/AudienceInsights/AudienceInsightsDashboardHeader'
import DemographicsGenderDoughnutChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsGenderDoughnutChart'
import DemographicsRaceBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsRaceBarChart'
import DemographicsAgeBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsAgeBarChart'
import DemographicsEducationBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsEducationBarChart'
import DemographicsIncomeBarChart from '@ui/Dashboard/Charts/Audience/Demographics/DemographicsIncomeBarChart'
import PersonasProfilesBarChart from '@ui/Dashboard/Charts/Audience/Personas/PersonasProfilesBarChart'

settings =
  name: 'AudienceInsightsDashboardView'

  resources:
    dashboard:
      resourceName: 'dashboard'
      slug: 'dashboard/audience_insights'
      fetch: false

  vue:
    props: ['organizer', 'options']

    components: {
      DashboardView,
      AudienceInsightsDashboardHeader,
      DemographicsGenderDoughnutChart,
      DemographicsRaceBarChart,
      DemographicsAgeBarChart,
      DemographicsEducationBarChart,
      DemographicsIncomeBarChart,
      PersonasProfilesBarChart,
    }

    methods:
      hiApplyFilter: ({ target }) ->
        @clearDataForResourceKey 'dashboard'
        @fetch 'dashboard', { target }

export default VueOptions.vue settings
